let initialState = "nnn";
const updtoken2 = (state = "", action) => {

    switch(action.type){ 
      case "SETUPDTOKEN2" : return action.parm;
      case "RESET": return initialState; //Always return the initial state
      default : return state;
  }
}

export default updtoken2